// Resolve investor / cover / attendee photo URLs so they load reliably in every
// environment. Handles three cases:
//   1. Empty / null → returns empty string (caller can render a placeholder).
//   2. Relative `/api/files/...` (from ImageUpload) → prepend REACT_APP_BACKEND_URL.
//   3. Absolute URL (http/https, data:, blob:) → return unchanged.

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function resolveImageUrl(url) {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("/api/") || trimmed.startsWith("/uploads/")) {
    return `${BACKEND}${trimmed}`;
  }
  return trimmed;
}

// Convenience for JSX <img>: returns `undefined` when there's no valid URL so
// React skips the `src` attribute entirely (avoids the "empty src re-fetches
// the page" browser warning).
export function imgSrc(url) {
  const resolved = resolveImageUrl(url);
  return resolved || undefined;
}
